import styled from "styled-components";

export const MfeSection = styled.section`
  height: 100%;
`
